import { PropsWithChildren, SVGAttributes, forwardRef } from 'react';
import {
  DALLAS_TEXT_COLOR_CLASSNAME_SEGMENTS,
  DallasTextColor,
} from '../types/typography';
import clsx from 'clsx';

import styles from './DallasSvgIcon.module.scss';

export interface Props
  extends Omit<SVGAttributes<SVGElement>, 'onClick' | 'color'> {
  color?: DallasTextColor;
}

const DallasSvgIcon = forwardRef<SVGSVGElement, PropsWithChildren<Props>>(
  function DallasSvgIcon(
    { className, children, color, ...svgProps }: PropsWithChildren<Props>,
    ref,
  ) {
    return (
      <svg
        viewBox="0 0 24 24"
        {...svgProps}
        ref={ref}
        className={clsx(
          className,
          styles.root,
          color &&
            styles[`color-${DALLAS_TEXT_COLOR_CLASSNAME_SEGMENTS[color]}`],
        )}
        xmlns="http://www.w3.org/2000/svg"
        strokeWidth={0}
        stroke="currentColor"
      >
        {children}
      </svg>
    );
  },
);

export default DallasSvgIcon;
